module.exports = __webpack_public_path__ + "img/zxtTitle.343cb3b2.png";